// components/support/SupportSystem.jsx
import React, { useState } from 'react';
// import RaiseTicket from './RaiseTicket';
// import HelpSupportCenter from './HelpSupportCenter';
// import LiveChatSupport from './LiveChatSupport';
// import FAQKnowledgeBase from './FAQKnowledgeBase';
import FoodRaiseTicket from './FoodRaiseTicket';

const FoodSupportSystem = () => {
  const [activeTab, setActiveTab] = useState('help-center');
  
  // Placeholder components for features not yet implemented
  const ComingSoon = ({ featureName }) => (
    <div className="coming-soon">
      <h3>{featureName} - Coming Soon</h3>
      <p>This feature is currently under development and will be available soon.</p>
    </div>
  );

  const tabs = [
    // { id: 'help-center', label: 'Help Center', component: <HelpSupportCenter /> },
    { id: 'raise-ticket', label: 'Raise a Ticket', component: <FoodRaiseTicket /> },
    // { id: 'live-chat', label: 'Live Chat', component: <ComingSoon featureName="Live Chat & Bot Support" /> },
    // { id: 'faq', label: 'FAQs', component: <ComingSoon featureName="FAQs & Knowledge Base" /> },
  ];

  return (
    <div className="support-system">
      <div className="support-header">
        <h1>Support System</h1>
        <p>Get help, report issues, or find answers to common questions</p>
      </div>
      
      <div className="support-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      
      <div className="support-content">
        {tabs.find(tab => tab.id === activeTab)?.component}
      </div>
    </div>
  );
};

export default FoodSupportSystem;